import StockTransfer from '../components/StockTransfer';

const PMPorductionIndent = () => {
  return <StockTransfer type="NON-JW" title="PM Stock Transfer" />;
};

export default PMPorductionIndent;
